import classNames from 'classnames';
import React from 'react';

type Props = {
  label?: string;
  className?: string;
  onClick: () => void;
  disabled?: boolean;
};
export const ContextMenuButton: React.FC<Props> = ({ label, onClick, className, children, disabled }) => {
  return (
    <button
      className={classNames(
        'flex gap-2 px-2 h-10 rounded-lg transition bg-transparent hover:bg-neue-journey-fg-10 items-center disabled:opacity-50',
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {label && <span className='text-neue-journey-medium'>{label}</span>}
    </button>
  );
};
